import {
	Button,
	Grid,
	Typography,
	useMediaQuery,
	useTheme,
} from "@valenzinsights/core-component";
import { ErrorGroupIconSvg, ValenzLogoIconSvg } from "@valenzinsights/images";
import { logout } from "@valenzinsights/services";

import { useEffect } from "react";

import { useMsal } from "@azure/msal-react";
import { redirect } from "react-router-dom";

export const Error401 = () => {
	const theme = useTheme();
	const isBelowMd = useMediaQuery(theme.breakpoints.down("md"));
	const { instance } = useMsal();
	const classes = {
		root: {
			backgroundColor: theme.palette.common.white,
			display: "flex",
			width: "100%",
			// overflowX: "hidden",
		},
		footer: {
			height: "5%",
			display: "grid",
			justifyContent: "center",
			alignContent: "center",
		},

		message: {
			fontSize: "32px !important",
			marginBottom: "10px !important",
			fontWeight: "600 !important",
		},
		content: {
			alignItems: "center",
			display: "flex",
		},
		contentImage: {
			display: "flex",
			height: "95%",
			alignItems: "center",
			justifyItems: "center",
		},
		contentContainer: {
			border: "1 solid black",
			display: "grid",
			paddingLeft: "15%",
			justifyContent: "center",
			alignContent: "center",
		},
		errorLogo: {
			width: "100%",
			height: "calc(100vh - 83px)",
			[theme.breakpoints.between("xs", "sm")]: {
				width: "100%",
				margin: "0 auto",
			},
		},
		link: {
			marginTop: "20px !important",
		},
		appLogo: {
			width: "300px",
			margin: isBelowMd ? "0 auto" : "unset",
			opacity: isBelowMd ? "0.2" : "1",
		},
	};

	useEffect(() => {
		logout(instance);
		redirect("/");
	}, []);

	return (
		<div style={classes.root}>
			<Grid container>
				<Grid item sm={12} xs={12} md={12} xl={12} lg={12} style={classes.content}>
					<div style={{ position: "relative", width: "100%" }}>
						<div
							style={{
								position: "absolute",
								width: "100%",
								textAlign: "center",
								top: "0px",
							}}
						>
							<img style={{ width: "200px" }} src={ValenzLogoIconSvg} alt="" />
						</div>
						<img style={classes.errorLogo} src={ErrorGroupIconSvg} />
						<div
							style={{
								position: "absolute",
								top: "0",
								display: "flex",
								flexDirection: "column",
								height: "100%",
								justifyContent: "center",
								paddingLeft: isBelowMd ? "60px" : "150px",
							}}
						>
							<div style={{ fontSize: "40px", fontWeight: "bold" }}>401</div>
							<div style={{ fontSize: "24px", fontWeight: "bold" }}>Oops !</div>
							<Typography style={classes.message}>Access Prohibited</Typography>
							<div>You dont have access to this page!</div>
							<div style={{ marginBottom: "10px" }}>
								We suggest you to logout and login again
							</div>
							<div>
								<Button variant="contained" onClick={() => logout(instance)}>
									Logout
								</Button>
							</div>
						</div>
					</div>
				</Grid>
			</Grid>
		</div>
	);
};
